import { render, staticRenderFns } from "./serverDetailStatusTab.vue?vue&type=template&id=0acd2758&scoped=true&"
import script from "./serverDetailStatusTab.vue?vue&type=script&lang=js&"
export * from "./serverDetailStatusTab.vue?vue&type=script&lang=js&"
import style0 from "./serverDetailStatusTab.vue?vue&type=style&index=0&id=0acd2758&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acd2758",
  null
  
)

export default component.exports